/**
 * Profilo di Palermo per il piè di pagina della schermata di accesso: Monte Pellegrino,
 * una cupola alla Teatro Massimo, un campanile, palme. Il mockup di GPT aveva uno skyline
 * di grattacieli, che a Palermo non esistono. Tinta unica sfumata ai lati: è decorazione,
 * non deve competere con il modulo.
 */
export default function Skyline(props) {
  return (
    <svg viewBox="0 0 400 64" aria-hidden="true" focusable="false" {...props}>
      <defs>
        {/* userSpaceOnUse: la sfumatura corre su tutto il profilo, non edificio per edificio */}
        <linearGradient id="skyline-sfuma" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="400" y2="0">
          <stop offset="0" stopColor="#c7d3e3" stopOpacity="0" />
          <stop offset=".22" stopColor="#c7d3e3" stopOpacity="1" />
          <stop offset=".78" stopColor="#c7d3e3" stopOpacity="1" />
          <stop offset="1" stopColor="#c7d3e3" stopOpacity="0" />
        </linearGradient>
      </defs>
      <g fill="url(#skyline-sfuma)">
        {/* Monte Pellegrino, più chiaro perché lontano */}
        <path opacity=".55" d="M0 64V46c10-6 18-16 30-24 10-7 22-10 36-10s26 4 36 12c8 6 16 14 26 20 8 4 18 7 32 8v12z" />
        <rect x="118" y="44" width="16" height="20" />
        <rect x="136" y="36" width="12" height="28" />
        <rect x="150" y="48" width="18" height="16" />
        <rect x="196" y="40" width="14" height="24" />
        <rect x="212" y="46" width="16" height="18" />
        {/* cupola */}
        <rect x="230" y="46" width="34" height="18" />
        <rect x="236" y="40" width="22" height="6" />
        <path d="M235 40a12 11 0 0 1 24 0z" />
        <rect x="245" y="23" width="4" height="7" />
        {/* campanile */}
        <rect x="270" y="30" width="9" height="34" />
        <path d="M268 30l6.5-8 6.5 8z" />
        <rect x="282" y="42" width="16" height="22" />
        <rect x="300" y="36" width="12" height="28" />
        <rect x="314" y="48" width="20" height="16" />
        <rect x="358" y="44" width="14" height="20" />
        <rect x="374" y="50" width="18" height="14" />
      </g>
      {/* palme */}
      <g fill="none" stroke="url(#skyline-sfuma)" strokeWidth="1.8" strokeLinecap="round">
        <path d="M181 64c1-10 1-18-1-26" />
        <path d="M180 38c-6-3-11-2-14 2M180 38c-3-6-8-8-13-7M180 38c5-4 10-4 14-1M180 38c3-5 8-7 12-6M180 38c0-5-2-8-5-10" />
        <path d="M345 64c1-9 1-16-1-23" />
        <path d="M344 41c-5-3-10-2-13 2M344 41c-3-5-7-7-12-6M344 41c5-3 9-3 13 0M344 41c3-4 7-6 11-5" />
      </g>
    </svg>
  );
}
